import MicroscopyExperimentViewer from "./MicroscopyExperimentViewer";
import usePresentSelector from './usePresentSelector';
import { useStore } from 'react-redux';
import G from './Getters';
import A from './ActionCreators';
import { ANNOTATION } from './UIConstants';
import { DIRECTORIES, IMAGE_SETS, IMAGE_UPLOADS } from './RecordTypes';
import ImageManagement from './ImageManagement';
import ImageCroppingContainer from './ImageCroppingContainer';
import DirectoryContentView from './DirectoryContentView';
import { FilesystemStore, FigureChannelAdjustmentContext } from './Contexts';

import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

export default function ImageAnnotation({selectedItemId,showSidebar,mode, showFilesystem}){

  

  let store = useStore();
  let state = store.getState();
  let selectedFilesystemItemId = selectedItemId || state.ui[ANNOTATION].selectedAnnotationsFilesystemId;


  let dispatch = useDispatch();


  if( selectedFilesystemItemId && G.isArchived(state,{_id:selectedFilesystemItemId}) ){
    dispatch(A.setSelectedAnnotationsItemContext({_id:null}));
  }

  const imageSets = usePresentSelector(state => Object.values(state.data.imageSets)); 


  let [ focusedFsItemIds, setFocusedFsItemIds ] = useState([selectedFilesystemItemId].filter(x => x));
  useEffect(() => {
    setFocusedFsItemIds([selectedItemId]);
  },[selectedItemId])
  //let [ focusedFsItemId, setFocusedFsItemId ] = useState(selectedFilesystemItemId||null);

  let singleFocusedItemId = focusedFsItemIds.length === 1 ? focusedFsItemIds[0] : null;
  if( singleFocusedItemId ){
    let isArchived = G.isArchived(state,{_id:singleFocusedItemId});
    if( isArchived ){
      G.isArchived(state,{_id:singleFocusedItemId});

      setFocusedFsItemIds([]);
    }
  }

  let focusedFsItems = usePresentSelector(state => {
    return focusedFsItemIds.filter(x => x).map(_id => G.getRecord(state,{_id}))
  })

  let selectedImageId;

  

  
  let singleFocusedImage = focusedFsItems.length === 1 && [IMAGE_SETS,IMAGE_UPLOADS].includes(focusedFsItems[0].type);
 
  let selectedDirectoryId;

  if( singleFocusedImage ){
    selectedImageId = G.getSelectedImageIdFromFsFocus(state,{focusedFsItemId:focusedFsItems[0]._id});
  }else if( focusedFsItems.length === 1 && focusedFsItems[0].type === "directories" ){
    selectedDirectoryId = focusedFsItems[0]._id;
    
  }else if( focusedFsItems.length === 1 && focusedFsItems[0].type === "processExecutions"){
    selectedDirectoryId = focusedFsItems[0]._id;
  }


  const [resizingImageManagement, setResizingImageManagement] = useState(false);
  let [imageManagementWidth,setImageManagementWidth] = useState(360);

  let croppingContainerContent;
  if( selectedImageId ){
    croppingContainerContent = (
      <ImageCroppingContainer 
        mode={mode}
        selectedImageId={selectedImageId} 
        showSidebar={showSidebar} 
        imageManagementWidth={imageManagementWidth}/>
    )
  }else if( selectedDirectoryId ){
    croppingContainerContent = false && (
      <DirectoryContentView processExecutionId={selectedDirectoryId}/>
    )

    croppingContainerContent = (
      <MicroscopyExperimentViewer _id={selectedDirectoryId}/>
    );
  }else{
    croppingContainerContent = (
        <div style={{fontSize:28, textAlign:'center',marginTop:200}} class="full-width">
          <div>
          Click an image on the
          <br/>
          left to annotate (crop).
          </div>

        </div>
      )
  }

  
  
  const mouseUp = () => setResizingImageManagement(false);
  const mouseMove = e => {
    if( resizingImageManagement === true ){
      setImageManagementWidth(e.clientX);
    }else{
    }
  }
  useEffect(() => {
    window.addEventListener('mouseup',mouseUp);
    window.addEventListener('mousemove',mouseMove);
    return () => {
      window.removeEventListener('mouseup',mouseUp);
      window.removeEventListener('mousemove',mouseMove);
    }
  })



  function onFilesystemItemEvent({
            _id,
            item,
            event
  }){

    let itemType = G.getItemType(state,_id);
    if( [IMAGE_SETS,IMAGE_UPLOADS].includes(itemType) ){

      dispatch(A.setSelectedAnnotationsItemContext({_id}));


      if( event.metaKey ){


        setFocusedFsItemIds(list => {
          return list.includes(_id) ? list.filter(x => x !== _id) : [...list, _id];
        })

      }else if( event.shiftKey ){


      }else{

        setFocusedFsItemIds([_id]);  
      }
    } else if (G.isRecordMicroscopyExperiment(state,{_id,itemType})) {

      setFocusedFsItemIds([_id]);  
      event.preventDefault();
      console.log('triggered');
    }
  }


  function getFilesystemContextOverrides(_id){
            let itemType = G.getItemType(state,_id);
            if (G.isRecordMicroscopyExperiment(state,{_id,itemType})){
              return {
                expandable:false
              }
            }
            return {};
          }
 
 
  let filesystem = (<div class="rel" style={{
    flexBasis:imageManagementWidth,
    background:'white',height:'100%',
    //borderRight:'1px solid #ccc',
  }}>


    <FilesystemStore.Provider value={{ 
      onFilesystemItemEvent,
      getFilesystemContextOverrides,
      isFilesystemItemSelected:(_id) => focusedFsItemIds.includes(_id)

    }}>
      <ImageManagement/>
    </FilesystemStore.Provider>


    <div onMouseDown={e => {
      setResizingImageManagement(true);
    }}
      style={{
        cursor:'ew-resize',
        top:0,
        position:"absolute", right:0, height:'100%', width:4, background:'#ccc'}}/>

  </div>)
  

  return (



    <div id="image-annotation-container" style={{position:'relative',width:'100%',height:'100%',

      //border:'3px solid magenta',
      minWidth:0,
      }} class="sg-row">

      
      
        
      {showFilesystem !== false && filesystem}

      

      <div style={{
        height:'100%',
        minWidth:0,
        //width:'100%',
        maxWidth:'100%',
        //border:'3px solid blue'
        }} class="sg-row flex-expand rel">
      {croppingContainerContent}
      </div>

    </div>
  )

}
